import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../Context/DataContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import FilterTabs from '../../components/FilterTabs/FilterTabs';
import Button from '../../components/Button/Button';
import styles from './Support.module.css';

const Support = () => {
  const [activeTab, setActiveTab] = useState('open');
  const { tickets, openTicketsCount } = useData();

  const pastSlaCount = tickets.filter((t) => t.isPastSla).length;
  const waitingCount = tickets.filter((t) => t.status.label === 'Waiting on user').length;

  const tabs = [
    { id: 'open', label: 'Open', count: openTicketsCount },
    { id: 'past_sla', label: 'Past SLA', count: pastSlaCount },
    { id: 'waiting', label: 'Waiting on user', count: waitingCount },
    { id: 'resolved', label: 'Resolved this week', count: 64 }
  ];

  const filteredTickets = tickets.filter((t) => {
    if (activeTab === 'past_sla') return t.isPastSla;
    if (activeTab === 'waiting') return t.status.label === 'Waiting on user';
    if (activeTab === 'resolved') return t.status.label === 'Resolved';
    return t.isOpen || activeTab === 'all';
  });

  const headerActions = (
    <>
      <Button
        variant="secondary"
        onClick={() => alert('Macros menu')}
      >
        Macros
      </Button>
      <Button
        variant="primary"
        onClick={() => alert('New ticket modal')}
      >
        + New ticket
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        title="Support"
        subtitle="Questions from participants and researchers."
        actions={headerActions}
      />

      <FilterTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Ticket</div>
          <div>From</div>
          <div>Subject</div>
          <div>Priority</div>
          <div>SLA</div>
          <div>Status</div>
          <div></div>
        </div>

        {filteredTickets.map((t) => (
          <div key={t.id} className={styles.tableRow}>
            <div>
              <span className={styles.ticketId}>{t.id}</span>
            </div>
            <div>
              <div className={styles.fromInfo}>
                <span className={styles.fromName}>{t.from}</span>
                <span className={styles.fromRole}>{t.fromRole}</span>
              </div>
            </div>
            <div className={styles.subjectText}>{t.subject}</div>
            <div>
              <span
                className={styles.badge}
                style={{ color: t.priority.color, background: t.priority.bg }}
              >
                {t.priority.label}
              </span>
            </div>
            <div className={styles.slaText}>{t.sla}</div>
            <div>
              <span
                className={styles.badge}
                style={{ color: t.status.color, background: t.status.bg }}
              >
                {t.status.label}
              </span>
            </div>
            <div>
              <Link to="/ticket-detail" className={styles.openLink}>
                Open →
              </Link>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Support;
